// 获取包名
export const getPackageName = ({ files }: any) => {
    const hasDirectory = files.some(v => v.name !== v.path)
    const hasFiles = files.some(v => v.name === v.path)

    // 多文件：压缩包名称为：【批量下载】图片1名称等.zip
    if (hasDirectory && hasFiles) {
        // 第一项是文件
        if (files[0].name === files[0].path) {
            const firstName = files[0].name.slice(0, files[0].name.lastIndexOf('.'))

            return `【批量下载】${firstName}等.zip`
        }

        // 第一项是文件夹
        const firstName = files[0].path.split('/')[0]

        return `【批量下载】${firstName}等.zip`
    }

    // 只有文件夹
    if (hasDirectory) {
        let directory: any = []

        for (let file of files) {
            const dirName = file.path.split('/')[0]

            if (!directory.includes(dirName)) {
                directory.push(dirName)
            }

            if (directory.length > 1) {
                break
            }
        }

        // 多文件夹
        if (directory.length > 1) {
            return `【批量下载】${directory[0]}等.zip`
        }

        // 单文件夹
        return `${directory[0]}.zip`
    }

    // 都是文件
    const firstName = files[0].name.slice(0, files[0].name.lastIndexOf('.'))

    return `【批量下载】${firstName}等.zip`
}

// 获取总size
export const getTotalSize = ({ files }: any) => {
    return files.reduce((t, c) => {
        t += c.size

        return t
    }, 0)
}

// 分包
export const getPackages = ({ files = [], maxSize }: any) => {
    const totalSize = getTotalSize({ files })

    if (maxSize && totalSize > maxSize) {
        return files.reduce((t, c) => {
            if (t.length) {
                const last = t[t.length - 1]
                const isOverflow = last.size + c.size > maxSize

                if (isOverflow) {
                    t.push({
                        files: [c],
                        size: c.size,
                    })
                } else {
                    last.files.push(c)
                    last.size += c.size
                }
            } else {
                t.push({
                    files: [c],
                    size: c.size,
                })
            }

            return t
        }, [])
    }

    return [
        {
            files,
            size: totalSize,
        },
    ]
}

export const getExtension = (str: string) => {
    if (typeof str === 'string') {
        const matched = str.match(/\.([^./]+)$/)

        if (Array.isArray(matched) && matched[0].startsWith('.')) {
            return matched[0]
        }
    }

    return ''
}
